import React from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape } from "react-intl";
import { Dropdown } from "semantic-ui-react";

/**
 * List of accepted planer task types
 */
export const Types = [
  {
    text: "agenda.planer.tasks.type.task",
    value: "task"
  },
  {
    text: "agenda.planer.tasks.type.exam",
    value: "exam"
  },
  {
    text: "agenda.planer.tasks.type.event",
    value: "event"
  }
];

/**
 * PlanerTypeSelector: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Dropdown selector component allowing the user to select
 * from a list of task types.
 *
 * @param {*} props
 */
const PlanerTypeSelector = props => (
  <Dropdown
    selection
    options={Types.map(type => ({
      ...type,
      text: props.intl.formatMessage({ id: type.text })
    }))}
    onChange={props.onChange}
    value={props.currentType}
    fluid
  />
);

PlanerTypeSelector.propTypes = {
  /**
   * intl: intlShape
   * Localization helper provided by react-intl
   */
  intl: intlShape.isRequired,
  /**
   * onChange: (event, sender) -> ()
   * Fired when the selected type in the dropdown has changed
   */
  onChange: PropTypes.func.isRequired,
  /**
   * currentType: String
   * Currently selected task type identifier
   */
  currentType: PropTypes.string.isRequired
};

export default injectIntl(PlanerTypeSelector);



// WEBPACK FOOTER //
// ./src/modules/agenda/planer/PlanerTypeSelector.js